var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRightAbroad = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9978 3C8.3678 3 2.9978 8.37 2.9978 15C2.9978 21.63 8.3678 27 14.9978 27C21.6278 27 26.9978 21.63 26.9978 15C26.9978 8.37 21.6278 3 14.9978 3ZM14.0753 21.99H12.0653L7.2053 15.18L9.2168 13.305L13.0703 16.905L20.7818 8.0085L22.7918 9.4185L14.0753 21.99Z",
    fill: "#4CAF50"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRightAbroad);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Right_abroad.af78b660f8097e8aa5df406aae992fba.svg";